module.exports = "/_next/static/images/9ecc797e0479641ecc612f25d5077f29-phone-with-app-open-and-card@1x-xs.jpg";